import { Box } from "@mui/material";
import * as React from "react";
import { PageData } from "../interfaces";
interface PropType {
  data: PageData;
}
interface StateType {
  loadState: String;
}

class LytHtmlPage extends React.Component<PropType, StateType> {
  state = {
    loadState: "loading",
  };

  htmlData?: string;

  componentDidMount = () => {
    this.getHTMLData();
  };

  componentDidUpdate(): void {
    this.getHTMLData();
  }

  getHTMLData = () => {
    return new Promise((resolve, reject) => {
      fetch(this.props.data.dataSrc as string)
        .then((response) => {
          return response.text();
        })
        .then((html) => {
          this.htmlData = html;
          this.setState(
            {
              loadState: "loaded",
            },
            () => {
              resolve(this.state.loadState);
            }
          );
        });
    });
  };

  render() {
    if (this.htmlData) {
      return (
        <Box id="lytHtmlPageWrapper">
          <div
            id={this.props.data.lable.toString()}
            dangerouslySetInnerHTML={{ __html: this.htmlData }}
          ></div>
        </Box>
      );
    } else {
      <p>Error loading html</p>;
    }
  }
}

export default LytHtmlPage;
